
import { defineComponent } from "vue";
import { Modal } from "bootstrap";
export default defineComponent({
  props: {
    enabled: Boolean
  },
  data() {
    return {
      modal: null as any
    };
  },
  mounted() {
    if (this.modal === null) {
      this.modal = new Modal(
        // @ts-ignore
        this.$refs.loadingModal as Element,
        {
          backdrop: "static",
          keyboard: false,
          focus: false
        }
      );
    }
  },
  watch: {
    enabled: function (newVal) {
      if (newVal) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    }
  }
});
